module.exports = __webpack_public_path__ + "static/media/kiwi-bird.f8f179fd.svg";